import { lazy } from "react";
import { authRoles } from "app/auth/authRoles";
import Loadable from "app/components/Loadable";

const Analytics = Loadable(lazy(() => import("./analytics-1")));

const dashboardRoutes = [
  { path: "/dashboard/default", element: <Analytics />, auth: authRoles.user },
];

export default dashboardRoutes;
